import React from 'react';
import VideoEmbed from './VideoEmbed';

const CALLOUT_STYLES = {
  info: { background: '#e6f2ff', border: '#2b6cb0', defaultLabel: 'Note' },
  tip: { background: '#e6ffe6', border: '#2f855a', defaultLabel: 'Pro tip' },
  warning: { background: '#fffbe6', border: '#b7791f', defaultLabel: 'Important' },
  critical: { background: '#ffe6f2', border: '#c53030', defaultLabel: 'Critical' }
};

const listItemContent = (item) => {
  if (item.term && item.text) {
    return <><strong>{item.term}:</strong> {item.text}</>;
  }
  if (item.term) {
    return item.term;
  }
  return item.text;
};

const ModuleBlock = ({ block }) => {
  switch (block.type) {
    case 'heading':
      return <h3>{block.text}</h3>;

    case 'paragraph':
      return block.leadIn ? (
        <p><strong>{block.leadIn}</strong> {block.text}</p>
      ) : (
        <p>{block.text}</p>
      );

    case 'list':
      return (
        <ul>
          {block.items.map((item, index) => (
            <li key={index}>{listItemContent(item)}</li>
          ))}
        </ul>
      );

    case 'callout': {
      const style = CALLOUT_STYLES[block.tone] || CALLOUT_STYLES.info;
      return (
        <div
          style={{
            backgroundColor: style.background,
            borderLeft: `6px solid ${style.border}`,
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px'
          }}
        >
          <p style={{ margin: '0 0 6px 0' }}><strong>{block.title || style.defaultLabel}</strong></p>
          <p style={{ margin: 0 }}>{block.text}</p>
        </div>
      );
    }

    case 'video':
      return <VideoEmbed youtubeId={block.youtubeId} title={block.title} credit={block.credit} />;

    case 'image':
      return (
        <figure style={{ margin: '0 0 20px 0' }}>
          <img
            src={block.src}
            alt={block.alt}
            style={{ width: '100%', maxWidth: '800px', display: 'block' }}
          />
          {block.caption && (
            <figcaption style={{ fontSize: '14px', color: '#555', marginTop: '6px' }}>{block.caption}</figcaption>
          )}
        </figure>
      );

    case 'linkOut':
      return (
        <p>
          <a href={block.href} target="_blank" rel="noreferrer">{block.label}</a> — {block.source}
        </p>
      );

    case 'doDont':
      return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
          <div style={{ minWidth: '280px', flex: '1 1 280px' }}>
            <p style={{ margin: '0 0 6px 0' }}><strong>DO</strong></p>
            <ul>
              {block.doItems.map((item, index) => (
                <li key={index}>{listItemContent(item)}</li>
              ))}
            </ul>
          </div>
          <div style={{ minWidth: '280px', flex: '1 1 280px' }}>
            <p style={{ margin: '0 0 6px 0' }}><strong>DO NOT</strong></p>
            <ul>
              {block.dontItems.map((item, index) => (
                <li key={index}>{listItemContent(item)}</li>
              ))}
            </ul>
          </div>
        </div>
      );

    case 'contact':
      return (
        <dl>
          {block.items.map((item, index) => (
            <div key={index} style={{ marginBottom: '10px' }}>
              <dt style={{ fontWeight: 'bold' }}>{item.label}</dt>
              <dd style={{ margin: 0 }}>
                {item.href ? <a href={item.href}>{item.value}</a> : item.value}
              </dd>
            </div>
          ))}
        </dl>
      );

    default:
      return null;
  }
};

const ModuleBlocks = ({ blocks }) => {
  return (
    <>
      {blocks.map((block, index) => (
        <ModuleBlock key={index} block={block} />
      ))}
    </>
  );
};

export default ModuleBlocks;
